import { connect } from 'react-redux';
import React from 'react';
import { array, string, bool } from 'prop-types';
import OverlaySpinner from 'dibs-overlay-spinner';
import CartNavDropdownListContent from './CartNavDropdownListContent';

import styles from './CartNav-style.scss';

const CartNavDropdownEmptyContent = () => {
    return (
        <div className={styles.emptyCart} data-tn="cart-nav-dropdown-cart-empty">
            Your cart is empty.
        </div>
    );
};

const CartNavDropdownLoadingContent = () => {
    return (
        <div className={styles.dropdownLoadingContent}>
            <OverlaySpinner
                position={'isStatic'}
                size={'medium'}
            />
        </div>
    );
};

const CartNavDropdownContent = ({ currency, isEmptyState, isUserTypeTrade, items }) => {
    items = items || {};

    if (isEmptyState) {
        return (
            <div className={styles.dropdownContent}>
                <CartNavDropdownEmptyContent/>
            </div>
        );
    }

    return (
        <div className={styles.dropdownContent}>
            {!items.edges ?
                <CartNavDropdownLoadingContent/> :
                <CartNavDropdownListContent
                    currency={currency}
                    isUserTypeTrade={isUserTypeTrade}
                    items={items}
                />
            }
        </div>
    );
};

CartNavDropdownContent.propTypes = {
    currency: string,
    isEmptyState: bool,
    isUserTypeTrade: bool,
    items: array
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade } = header;

    return {
        isUserTypeTrade
    };
};

export default connect(mapStateToProps)(CartNavDropdownContent);



// WEBPACK FOOTER //
// ./src/components/CartNav/CartNavDropdownContent.jsx